import React from "react";
import Typography from "@material-ui/core/Typography";
import "./Recordcom.css";
const Redrecord = ({ bgcolor, numresult, period }) => {
  const typecast = period.toString();
  const first = typecast.substring(9, 12);
  const firstcolor = bgcolor[0];
  const seocondcolor = bgcolor[1];

  
  return (
    <>
      <div className="record-main-no">
        <Typography
          style={{ fontSize: "10px", marginLeft: "10px" }}
          justifyContent="center"
        >
          {first}
        </Typography>
        <div
          className="recordcomm"
          style={{
            background:
              seocondcolor && firstcolor
                ? `linear-gradient( to right,${firstcolor} 0%,${firstcolor} 50%,${seocondcolor} 50%,${seocondcolor} 100% )`
                : firstcolor,
          }}
        >
          <span >{numresult}</span>
        </div>
      </div>
    </>
  );
};

export default Redrecord;
